import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { basketActions, selectWorkBasket, selectWorkCart } from '../../app/basket-slice';
import { configuratorActions, glbURLSelector, pdfURLSelector, savingConfigurationSelector } from '../../app/configurator-slice';
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { appContextSelector, isAnonymousSelector, isRedirectedFromSalesSelector, salesInfoSelector } from '../../app/main-slice';
import { closePopup, showPopup } from "../../app/popup-slice";
import { useMessages2 } from "../../hooks/useLanguage";
import { download } from '../../util/download-print';
import { NOT_READY_YET } from '../../view/debug-info';
import { ButtonBar, DownloadButton, PrintButton } from "../buttons";
import { chosenConfiguratorSelector } from '../../app/configurator-selectors';

import styles from './save-configuration-dialog.module.css';
import { useEffect, useState } from "react";

export const SaveConfigDialog = () => {

    const dispatch = useAppDispatch()
    const { messages } = useMessages2();
    const isSaving = useAppSelector(savingConfigurationSelector);
    const pdfURL = useAppSelector(pdfURLSelector);
    const glbURL = useAppSelector(glbURLSelector);
    const { familyId, variantId } = useAppSelector(chosenConfiguratorSelector);
    const isAnonymous = useAppSelector(isAnonymousSelector);
    const workBasket = useAppSelector(selectWorkBasket);
    const workCart = useAppSelector(selectWorkCart);
    const appContext = useAppSelector(appContextSelector);
    const salesInfo = useAppSelector(salesInfoSelector);
    const isRedirectedFromSales = useAppSelector(isRedirectedFromSalesSelector);
    
    // Debug: Log salesInfo state
    useEffect(() => {
        console.log('SaveConfigDialog - salesInfo:', salesInfo);
        console.log('SaveConfigDialog - isRedirectedFromSales:', isRedirectedFromSales);
    }, [salesInfo, isRedirectedFromSales]);

    // const [shouldDownload, setShouldDownload] = useState(false);
    // const [shouldPrint, setShouldPrint] = useState(false);


    const handleClose = () => {
        dispatch(closePopup())
        dispatch(configuratorActions.setGlbURL(undefined));
    }

    const handleSales = () => {
        dispatch(configuratorActions.sendSalesParameters());
    }

    const addToBasket = () => {
        dispatch(basketActions.addProductToCart());
    }

    const goToBasket = () => {
        dispatch(showPopup({ dialog: 'baskets' }));
        dispatch(basketActions.editCart(workCart!));
    }

    // useEffect(() => {
    //     if (pdfURL) {
    //         if (shouldDownload) {
    //             handleDownloadEvent();
    //             setShouldDownload(false);
    //         }
    //         if (shouldPrint) {
    //             handlePrintEvent();
    //             setShouldPrint(false);
    //         }
    //     }
    // }, [pdfURL, shouldDownload, shouldPrint]);



    // const handleDownloadEvent = () => {
    //     if(pdfURL) {
    //         download(pdfURL, 'pdf', 'application/pdf');
    //     }
    // }

    // const handlePrintEvent = () => {
    //     const printWindow = window.open(pdfURL, '_blank');
    //     printWindow?.addEventListener('load', () => {
    //         printWindow.print();
    //     });
    // }
    

    // const handleDownloadPDF = async () => {
    //     if (pdfURL) {
    //         handleDownloadEvent();
    //     } else {
    //         await dispatch(generatePDFAsync());
    //         setShouldDownload(true);
    //     }
    // };
    
    // const handlePrintPDF = async () => {
    //     if (pdfURL) {
    //         handlePrintEvent();
    //     } else {
    //         await dispatch(generatePDFAsync());
    //         setShouldPrint(true);
    //     }
    // };
    
    

    const hasAddToBasket = !isAnonymous && workBasket === undefined;
    const hasGoToBasket = !isAnonymous && workBasket !== undefined;

    const dateISO = new Date().toISOString();
    const dateStr = dateISO.substring(0,10) + '_' + dateISO.substring(11,16).replaceAll(':','-');
    const glbSuggestedName = `${familyId}${variantId ? '-' : ''}${variantId ?? ''}_${dateStr}.glb`;

    const handleDownloadGLB = async () => {
        if(glbURL) {
            download(glbURL, 'glb', 'model/gltf-binary', glbSuggestedName);
        }
    }

    return (
        <div className={styles.dialogContainer}>
        
            <div className={styles.topContent}>
                <div className={styles.title}>
                    <h2>{messages?.offer_pagetitle}</h2>
                </div>
                
                <FontAwesomeIcon
                    icon={faXmark}
                    className={styles.closeButton}
                    onClick={handleClose}
                />
            </div>
                
            <div className={styles.infoContainer} >

                <ButtonBar className={styles.buttonsLeftBar}>
                    <DownloadButton disabled={isSaving} url={pdfURL} extension="pdf" mimeType="application/pdf" centered={true}>{messages?.offer_save_button ?? ''}</DownloadButton>
                    { appContext !== 'stapp' ? 
                        <PrintButton disabled={isSaving} url={pdfURL} centered={true}>{messages?.["offer_print-button"] ?? ''}</PrintButton>
                        : null
                    } 

                    {/*<button
                        className={styles.downloadButton} // mimic DownloadButton styles
                        disabled={isSaving}
                        onClick={handleDownloadPDF}
                    >
                        {messages?.offer_save_button ?? ''}
                    </button>

                    { appContext !== 'stapp' && (
                        <button
                            className={styles.printButton} // mimic PrintButton styles
                            disabled={isSaving}
                            onClick={handlePrintPDF}
                        >
                            {messages?.["offer_print-button"] ?? ''}
                        </button>
                    )}*/}
                    
                    { hasAddToBasket ? <button onClick={addToBasket} disabled={isSaving}>{messages?.basket_add_to_basket ?? ''}</button> 
                                     : null
                    }
                    { hasGoToBasket ? <button onClick={goToBasket} disabled={isSaving}>{messages?.show_basket_button ?? ''}</button> 
                                    : null
                    }

                    <NOT_READY_YET><button>{messages?.offer_send_button}</button></NOT_READY_YET>
                </ButtonBar>

                <ButtonBar className={styles.buttonsRightBar}>
                    <button onClick={handleDownloadGLB} disabled={glbURL === undefined}>{messages!['offer_3D-button_glb']}</button>
                </ButtonBar>
                <NOT_READY_YET>
                    <ButtonBar className={styles.buttonsRightBar}>
                        <button>{messages!['offer_3D-button_obj']}</button>
                        <button>{messages!['offer_3D-button_obj']}</button>
                    </ButtonBar>
                </NOT_READY_YET>
            
                <ButtonBar className={styles.bottomBar}>
                    <button className={styles.backButton} onClick={handleClose}>{messages?.offer_return_to_configuration}</button>
                    <NOT_READY_YET><button className={styles.basketButton}>{messages!.add_to_basket_button}</button></NOT_READY_YET>
                    {
                        isRedirectedFromSales ? 
                            <button onClick={handleSales}>VK Parameter</button>
                            :
                            null
                    }
                    
                </ButtonBar>
            </div> 
        </div>
    )
}